// Tags to identify the client flow and blueprint
export const TAG_CLIENT_BLUEPRINT = 'aa3e5fbc-fa6d-4be0-8d95-de04bae4552f';
export const TAG_CLIENT_FLOW = '366ec075-da2f-43bc-b99c-464d0b1314e7';

const flowName = 'Accelerated Agreements for Clients';

export const getClientAgreementFlowDsl = (blueprintId: string) => {
	return `flow:\n  name: ${flowName}\n  description: Send agreement to client\n  active: true\n  tags:\n    \'${TAG_CLIENT_FLOW}\': true\n  spec:\n    blueprintRef: ${blueprintId}\n    params: []\n`;
};
